import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

let exportFileMixin = {
	methods: {
		exportFile: function (searchCriteria, quickFind, restEntity, fileType = 'pdf') {
			if (quickFind && searchCriteria.length === 0 || searchCriteria === '') {
				if(!confirm('You are about to export all related line items. Are you sure?')) {
					return
				}
			}

			this.show = true

			let payload = {}
			payload.fileType = fileType
			payload.recordType = restEntity.includes('yb') ? 'yb' : 'cn'

			if (quickFind) {
				payload.quickFind = true
				payload.quickFindCriteria = searchCriteria && searchCriteria.length > 0 ? searchCriteria : ''
			} else {
				payload.search = true
				if (searchCriteria && searchCriteria.length > 0) {
					let searchCriteriaTransformed = []
					searchCriteria.forEach(searchCriterion => {
						let searchCriterionTransformed = {
							"omit": false,
							"criteria": {}
						}
						for (const key in searchCriterion) {
							if (searchCriterion.hasOwnProperty(key)) {
								let value = searchCriterion[key]
								if (key === 'omit' && value === 'true') {
									searchCriterionTransformed.omit = true
								} else if(key !== 'omit') {
									searchCriterionTransformed["criteria"][key] = value
								}
							}
						}
						searchCriteriaTransformed.push(searchCriterionTransformed)
					})
					payload.searchCriteria = searchCriteriaTransformed
				}
			}

			this.axios.post(`/3ds/api/${restEntity}/export`, payload, {
				headers: {
					'Authorization': 'Bearer ' + this.token
				},
			})
				.then(value => {
					console.log('File export succeeded')
					console.log(JSON.stringify(value))
					this.showExportModal = true
					this.exportModalUrl = value.data.data[0].fieldData.Container
					this.exportModalFileType = fileType
					this.exportModalFileName = "export." + fileType
				})
				.catch(reason => {
					console.error('File export failed')
					console.error(JSON.stringify(reason))
				})
				.finally(() => this.show = false)
		}
	},
	data() {
		return {
			showExportModal: false,
			exportModalUrl: null,
			exportModalFileName: null,
			exportModalFileType: null
		}
	}
}

export default exportFileMixin